import $ from "jquery";

Drupal.behaviors.bibuStatusMessages = {
  attach: function (context) {
    const $button = $(".close-status-message");

    $button.on("click", function () {
      let $region = $(this).closest('[role="contentinfo"]'),
        ariaHidden = $region.attr("aria-hidden");

      if (ariaHidden == "false") {
        $region.attr("aria-hidden", "true");
      }
    });
  },
};
